import React, { useContext, useEffect, useState } from 'react';
import { PagamentosContainer } from './styles';
import { useTheme } from '../../../../contexts/Theme/ThemeContext';
import { Button } from '../../../Button';
import { tinyApi, FormaPagamentoTiny } from '../../../../hooks/tinyApi';
import Swal from 'sweetalert2';
import LoadingComFundo from '../../../Loading/LoadingComFundo/LoadingComFundo';
import { ConfiguracoesContext } from '../../../../contexts/Configuracoes/ConfiguracoesContext';
import { Select } from '../../../Select';

interface PagamentosProps {
    onClose: () => void;
}

type TipoPagamento = 'a_combinar' | 'pix' | 'cartao';

interface MeioPagamento {
    tipo: TipoPagamento;
    label: string;
}

const MEIOS_PAGAMENTO: MeioPagamento[] = [
    { tipo: 'pix', label: 'PIX' },
    { tipo: 'cartao', label: 'Cartão de Crédito' },
    { tipo: 'a_combinar', label: 'A combinar' },
];

const Pagamentos: React.FC<PagamentosProps> = ({ onClose }) => {
    const api = tinyApi();
    const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
    const { theme } = useTheme();

    const [loading, setLoading] = useState(true);
    const [formasTiny, setFormasTiny] = useState<FormaPagamentoTiny[]>([]);
    const [mapeamentoAux] = useState(
        configuracoes.dados_tiny_v2?.mapeamento_pagamentos || {}
    );

    const buscarPagamentos = async () => {
        try {
            const response = await api.buscarFormasPagamento();
            setFormasTiny(response.formas || []);

            if (response.erro) {
                Swal.fire({
                    title: 'Atenção',
                    text: 'Não foi possível carregar as formas cadastradas no Tiny. Apenas as formas padrão estão disponíveis.',
                    icon: 'warning',
                    confirmButtonText: 'Ok'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Erro',
                text: 'Ocorreu um erro ao buscar as formas de pagamento. Tente novamente.',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
            onCancelar();
        }
    };

    const onCancelar = () => {
        setConfiguracoes({
            ...configuracoes,
            dados_tiny_v2: {
                ...configuracoes.dados_tiny_v2!,
                mapeamento_pagamentos: mapeamentoAux
            }
        });
        onClose();
    };

    const handleChangeMapeamento = (tipo: TipoPagamento, value: string) => {
        const novoMapeamento = {
            ...configuracoes.dados_tiny_v2?.mapeamento_pagamentos,
        };

        if (value === '') {
            delete novoMapeamento[tipo];
        } else {
            novoMapeamento[tipo] = value;
        }

        setConfiguracoes({
            ...configuracoes,
            dados_tiny_v2: {
                ...configuracoes.dados_tiny_v2!,
                mapeamento_pagamentos: novoMapeamento
            }
        });
    };

    useEffect(() => {
        const init = async () => {
            await buscarPagamentos();
            setLoading(false);
        };
        init();
    }, []);

    const optionsPagamento = [
        { name: 'Não mapear', value: '' },
        ...formasTiny.map(f => ({
            name: f.descricao,
            value: f.codigo
        }))
    ];

    return (
        <PagamentosContainer theme={theme} loading={loading}>
            {loading ? (
                <LoadingComFundo />
            ) : (
                <>
                    <div className="titulo">
                        Mapear pagamentos
                    </div>
                    <div className="texto">
                        Vincule os meios de pagamento do Conecta Venda às formas de pagamento cadastradas no Tiny.
                        A empresa utilizada na cobrança (Mercado Pago, por exemplo) é enviada automaticamente
                        conforme o intermediador de cada pedido.
                    </div>
                    <div className="pagamentos">
                        {MEIOS_PAGAMENTO.map((meio) => (
                            <div key={meio.tipo} className="pagamento">
                                <Select
                                    label={meio.label}
                                    placeholder="Selecione uma forma de pagamento"
                                    options={optionsPagamento}
                                    value={
                                        configuracoes.dados_tiny_v2?.mapeamento_pagamentos?.[meio.tipo] || ''
                                    }
                                    onChange={(value) => handleChangeMapeamento(meio.tipo, value)}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="botoes">
                        <div className="cancelar" onClick={onCancelar}>
                            Cancelar
                        </div>
                        <Button
                            title="Salvar"
                            onClick={onClose}
                        />
                    </div>
                </>
            )}
        </PagamentosContainer>
    );
};

export default Pagamentos;
